import { render, staticRenderFns } from "./VerticalBarChart.vue?vue&type=template&id=c65b7d30"
import script from "./VerticalBarChart.vue?vue&type=script&lang=js"
export * from "./VerticalBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c65b7d30')) {
      api.createRecord('c65b7d30', component.options)
    } else {
      api.reload('c65b7d30', component.options)
    }
    module.hot.accept("./VerticalBarChart.vue?vue&type=template&id=c65b7d30", function () {
      api.rerender('c65b7d30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Visualisations/VerticalBarChart.vue"
export default component.exports